import React, { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';
import { DateUtils } from '@vectord/utils';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';

import {
  BLACKLIST_MANAGE_MODAL_STAGES,
  setBlacklistedMenteeManageLearner,
  setPersonalisedMenteeEmailersManageModalStage,
} from 'features/communicationManagement';
import styles from './PersonalisedMenteeEmailersTableBody.module.scss';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

export default function PersonalisedMenteeEmailersTableBody({
  blacklistedLearners,
  blacklistedLearnersMeta,
}) {
  const dispatch = useDispatch();

  const handleManageLearner = useCallback(
    (learner, userName, userEmail, superBatchName) => {
      const learnerDetail = {
        ...learner,
        user_name: userName,
        user_email: userEmail,
        super_batch_name: superBatchName,
      };

      batch(() => {
        dispatch(setBlacklistedMenteeManageLearner(learnerDetail));
        dispatch(
          setPersonalisedMenteeEmailersManageModalStage(
            BLACKLIST_MANAGE_MODAL_STAGES.manage
          )
        );
      });
    },
    [dispatch]
  );

  return (
    <TableBody>
      {blacklistedLearners?.map((learner) => (
        <TableRow
          key={`snoozed-learner-${learner.blocker_id}`}
          className={styles.root}
        >
          <TableCell>
            {blacklistedLearnersMeta.user_names[learner.blocker_id]}
          </TableCell>
          <TableCell>
            {blacklistedLearnersMeta.user_emails[learner.blocker_id]}
          </TableCell>
          <TableCell>
            {blacklistedLearnersMeta.super_batch_names[learner.blocker_id]}
          </TableCell>
          <TableCell>{DateUtils.toDDMMMYYYY(learner.start_date)}</TableCell>
          <TableCell>{DateUtils.toDDMMMYYYY(learner.end_date)}</TableCell>
          <TableCell>
            <Tappable
              className={classNames(styles.manageCommsLearner, 'p-v-xxs')}
              onClick={() =>
                handleManageLearner(
                  learner,
                  blacklistedLearnersMeta.user_names[learner.blocker_id],
                  blacklistedLearnersMeta.user_emails[learner.blocker_id],
                  blacklistedLearnersMeta.super_batch_names[learner.blocker_id]
                )
              }
            >
              Manage
            </Tappable>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
}
